"use client";
import { jsx, jsxs } from "react/jsx-runtime";
import { motion, useAnimation } from "motion/react";
import { forwardRef, useCallback, useImperativeHandle, useRef } from "react";
import { cn } from "../../../utils/index.js";
const pathVariants = {
    normal: {
        scale: 1
    },
    animate: {
        pathLength: [
            0,
            1
        ]
    }
};
const Check = /*#__PURE__*/ forwardRef(({ onMouseEnter, onMouseLeave, className, size = 24, ...props }, ref)=>{
    const controls = useAnimation();
    const isControlledRef = useRef(false);
    useImperativeHandle(ref, ()=>{
        isControlledRef.current = true;
        return {
            startAnimation: ()=>controls.start('animate'),
            stopAnimation: ()=>controls.start('normal')
        };
    });
    const handlePointerEnter = useCallback((e)=>{
        if (isControlledRef.current) onMouseEnter?.(e);
        else controls.start('animate');
    }, [
        controls,
        onMouseEnter
    ]);
    const handlePointerLeave = useCallback((e)=>{
        if (isControlledRef.current) onMouseLeave?.(e);
        else controls.start('normal');
    }, [
        controls,
        onMouseLeave
    ]);
    return /*#__PURE__*/ jsx("div", {
        onPointerEnter: handlePointerEnter,
        onPointerLeave: handlePointerLeave,
        className: cn(className),
        ...props,
        children: /*#__PURE__*/ jsxs("svg", {
            xmlns: "http://www.w3.org/2000/svg",
            width: size,
            height: size,
            viewBox: "0 0 24 24",
            fill: "none",
            stroke: "currentColor",
            strokeWidth: "2",
            strokeLinecap: "round",
            strokeLinejoin: "round",
            className: "duration-long ease-in-out",
            "aria-label": "Check icon",
            children: [
                /*#__PURE__*/ jsx("title", {
                    children: "Check icon"
                }),
                /*#__PURE__*/ jsx(motion.path, {
                    variants: pathVariants,
                    initial: "normal",
                    animate: controls,
                    d: "m5.5 12.5 4 4 9-9"
                })
            ]
        })
    });
});
export { Check };
